import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { runInBackground } from '../../../configuration/setup/backgroundActions';
import { TRANSPORT_ORDER_ROUTE, WELCOME_ROUTE } from './routes';

export const DefaultRedirect = (props: { isActive: boolean }) => {
    const navigate = useNavigate();

    useEffect(
        () =>
            runInBackground(async () => {
                await navigate(props.isActive ? TRANSPORT_ORDER_ROUTE : WELCOME_ROUTE);
            }, 'DefaultRedirect'),
        [navigate, props.isActive],
    );

    return null;
};
